import axios from '@/utils/axios';

// Types

// API

export default {
	async getAll(serviceID: number): Promise<any[]> {
		return (await axios().get(`/timeRanges/?serviceID=${serviceID}`)).data;
	},

	async getOne(timeRangeID: number): Promise<any> {
		return (await axios().get(`/timeRanges/${timeRangeID}/`)).data;
	},

	async create(payload: any): Promise<any> {
		return (await axios().post(`/timeRanges/`, payload)).data;
	},
	async edit(id: number, payload: any): Promise<any> {
		return (await axios().patch(`/timeRanges/${id}`, payload)).data;
	},

	async remove(timeRangeID: number): Promise<any> {
		return (await axios().delete(`/timeRanges/${timeRangeID}`)).data;
	},
};
